module.exports = __webpack_public_path__ + "img/front-page.544efa59.svg";